import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import NavRow from '../fields/NavRow';
import RadioField from '../fields/RadioField';
import { TaskDefinition, TaskStepRenderArgs } from '../QuestionnaireShell';
import { DiscountValues } from '../types';
import { zodResolver } from '../validation';

const schema = z.object({
  discountAgreementAccepted: z.enum(['Yes', 'No'], {
    required_error: 'Please choose Yes or No',
    invalid_type_error: 'Please choose Yes or No',
  }),
});

const DEFAULTS: Partial<DiscountValues> = {};

const DiscountForm = ({ initialValues, onComplete, onBack, onCancelEdit, submitLabel }: TaskStepRenderArgs) => {
  const defaults = (initialValues as DiscountValues | undefined) ?? (DEFAULTS as DiscountValues);
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<DiscountValues>({
    defaultValues: defaults,
    resolver: zodResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = handleSubmit((values) => onComplete(values));

  return (
    <form className="rnq-form" onSubmit={(e) => e.preventDefault()}>
      <RadioField
        control={control}
        name="discountAgreementAccepted"
        options={[
          { title: 'Yes', value: 'Yes' },
          { title: 'No', value: 'No' },
        ]}
        required
      />
      <NavRow
        onBack={onBack}
        onCancelEdit={onCancelEdit}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
        disabled={!isValid}
      />
    </form>
  );
};

const Discount: TaskDefinition = {
  key: 'task13',
  label: 'Discount',
  title: 'Are you willing to provide a 25% discount to your standard hourly rate?',
  render: (args) => <DiscountForm {...args} />,
};

export default Discount;
